/**
 * Shared user-facing info/disclaimer texts.
 * The area wordings are mirrored in the iOS app (InfoTexts in
 * ReadOnlySheetShared.swift) — keep them in sync when changing.
 */
export const AREA_ESTIMATE_INFO =
    'Manuellt grovt uppmätt vid inventering. Ej avsett som underlag för juridiska ändamål.';

/** Tooltip on a verified Golvyta row. `date` is the YYYY-MM-DD part of `verifiedWhen`. */
export const floorAreaVerifiedInfo = (date: string, userName: string, comment?: string): string =>
    `Uppmätt på ritning ${date} av ${userName}.` + (comment ? `\n${comment}` : '');

/** Extra line under the estimate disclaimer when a verification has gone stale. */
export const floorAreaStaleNote = (date: string): string =>
    `Tidigare uppmätt på ritning ${date}; golv ändrat därefter.`;

/** Pencil tooltip when the room has no floor component to carry the area. */
export const FLOOR_AREA_NO_FLOOR_HINT = 'Rummet har inget golv – lägg till ett i appen';

/** Note in the maintenance draft's Mängd modal for a floor in a verified room. */
export const FLOOR_AREA_DRAFT_NOTE =
    'Rummets golvyta är uppmätt på ritning – sparar du en ny mängd gäller verifieringen inte längre.';
